import { useState } from "react";
import "../css/animatedText.css";

const AnimatedText = ({ label, number }) => {
  const [isPaused, setIsPaused] = useState(false);

  return (
    <div className="wrapper">
      <div className="container">
        <div className="text-center animated">
          <h2
            className={`animated-text ${isPaused ? "paused" : ""}`}
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
          >
            {number}
          </h2>

          <p className="description">{label}</p>
        </div>
      </div>
    </div>
  );
};

export default AnimatedText;
